export default class {
    constructor(startTime, endTime) {
        this.startTime = startTime;
        this.endTime = endTime;
    }

    minutesFromStartOfDay() {
        return {
            startTime: this.startTime.minutesFromStartOfDay(),
            endTime: this.endTime.minutesFromStartOfDay(),
        }
    }

    isValid() {
        return (this.endTime.minutesFromStartOfDay() - this.startTime.minutesFromStartOfDay()) >= 30;
    }
}
